{
  "tabs": {
    "chat": "Resaka",
    "reminders": "Fampahatsiahivana",
    "calendar": "Kalandrie",
    "settings": "Fikirakirana"
  },
  "common": {
    "cancel": "Hanafoana",
    "save": "Tehirizo",
    "confirm": "Manamafy",
    "delete": "Fafao",
    "back": "Miverina",
    "close": "Akatona",
    "edit": "Hanova",
    "search": "Mitady",
    "all": "Rehetra",
    "loading": "Entina...",
    "error": "Nisy tsy nety",
    "notFound": "Tsy hita",
    "tryAgain": "Azafady andramo indray",
    "retry": "Andramo indray",
    "undo": "Avereno",
    "pullToRefresh": "Sintonina hanavao",
    "justNow": "vao haingana"
  },
  "auth": {
    "welcome": "Tongasoa eto amin'ny FishMemory",
    "tagline": "Mpanampy fampahatsiahivana WhatsApp anao, ao anaty paosin-tanana.",
    "subtitle": "Mpanampy fampahatsiahivana WhatsApp anao, ao anaty paosin-tanana.",
    "phoneLabel": "Nomeraon-telefaonina WhatsApp anao",
    "phoneHint": "Handefa kaody fanamarinana amin'ny WhatsApp izahay",
    "invalidPhone": "Azafady ampidiro nomeraon-telefaonina marina",
    "continue": "Tohizo",
    "enterPhone": "Ampidiro ny nomeraon-telefaonina WhatsApp anao",
    "phonePlaceholder": "Nomeraon-telefaonina",
    "sendCode": "Alefaso ny Kaody",
    "verifyTitle": "Hamarino ny nomeraonao",
    "otpSentTo": "Kaody 6 isa nalefa tamin'ny {{phone}} tamin'ny WhatsApp",
    "enterFullCode": "Azafady ampidiro ny isa 6 rehetra",
    "invalidOtp": "Kaody tsy mety. Azafady andramo indray.",
    "otpFailed": "Tsy nahomby ny fandefasana kaody. Andramo indray.",
    "otpResent": "Kaody nalefa indray",
    "resendIn": "Alefa indray ao anatin'ny {{seconds}}s",
    "resendCode": "Alefa indray ny kaody",
    "enterOtp": "Ampidiro ny kaody nalefa tamin'ny WhatsApp anao",
    "verify": "Hamarino",
    "resend": "Alefa indray ny kaody",
    "wrongNumber": "Nomerao diso?",
    "backToPhone": "Miverina amin'ny telefaonina",
    "editPhone": "Hanova nomeraon-telefaonina",
    "error": "Hadisoana",
    "setupTitle": "Andao hanamboatra",
    "setupSubtitle": "Afaka manova ireo ianao any aoriana ao amin'ny Fikirakirana",
    "namePlaceholder": "Anaranao",
    "letsGo": "Vita ny fanamboarana",
    "skipForNow": "Aleo aloha"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Soraty ny hafatra...",
    "inputPlaceholder": "Soraty ny hafatra...",
    "typing": "FishMemory manoratra...",
    "online": "Mifandray",
    "connecting": "Mifandray...",
    "reconnecting": "Mifandray indray...",
    "offline": "Tsy mifandray",
    "empty": "Atombohy ny resaka",
    "emptyHint": "Mametraha fampahatsiahivana, jereo ny fandaharam-potoana, na mangataha fanampiana.",
    "emptyAction": "Alefaso fampahatsiahivana santionany",
    "actions": "Hetra resaka",
    "keep": "Tazomy ny hafatra",
    "clearTitle": "Fafao ny resaka",
    "clearConfirm": "Fafao daholo ny hafatra rehetra amin'ity fitaovana ity? Tsy azo averina izany.",
    "clear": "Fafao ny resaka",
    "optionSelected": "Voafidy: {{label}}",
    "sendingSelection": "Alefa...",
    "connectionLost": "Mifandray indray..."
  },
  "reminders": {
    "title": "Fampahatsiahivako",
    "active": "Miasa",
    "today": "Anio",
    "thisWeek": "Ity herinandro",
    "history": "Tantara",
    "items": "entana",
    "emptyTitle": "Tsy misy fampahatsiahivana",
    "emptySubtitle": "Mametraha iray avy amin'ny resaka dia hiseho eto.",
    "emptyAction": "Sokafy ny resaka",
    "filterActive": "Miasa",
    "filterToday": "Anio",
    "filterWeek": "Ity herinandro",
    "filterHistory": "Tantara",
    "emptyState": "Tsy misy fampahatsiahivana. Atombohy ny resaka!",
    "swipeDone": "Vita",
    "swipeSnooze": "Atsaharo vetivety",
    "swipeDelete": "Fafao",
    "search": "Mitady fampahatsiahivana...",
    "upcoming": "Ho avy",
    "completed": "Vita",
    "overdue": "Latsaka andro",
    "tomorrow": "Rahampitso",
    "synced": "Nifanaraka {{value}}",
    "swipeHint": "Sintonina ny fampahatsiahivana ho an'ny hetsika fanampiny",
    "noResults": "Tsy misy fampahatsiahivana mifanaraka amin'ny fikarohana",
    "noResultsHint": "Andramo teny hafa na fafao ny fikarohana",
    "deleteAllFailed": "Tsy tafavoaka ny famafana fampahatsiahivana rehetra"
  },
  "calendar": {
    "title": "Kalandrie",
    "today": "Anio",
    "tomorrow": "Rahampitso",
    "completed": "vita",
    "noEvents": "Tsy misy fandaharana",
    "noEventsSubtitle": "Safidio ny daty hijerena fampahatsiahivana sy hetsika kalandrie.",
    "googleEvent": "Google Kalandrie",
    "legendActive": "Miasa",
    "legendRecurring": "Miverimberina",
    "legendDone": "Vita",
    "legendGoogle": "Google",
    "previousMonth": "Volana teo",
    "nextMonth": "Volana manaraka",
    "previousYear": "Taona teo",
    "nextYear": "Taona manaraka",
    "goToToday": "Mankanesa amin'ny anio",
    "all": "Rehetra",
    "active": "Miasa",
    "done": "Vita",
    "paused": "Nijanona"
  },
  "settings": {
    "title": "Fikirakirana",
    "profile": "Mombamomba",
    "name": "Anarana aseho",
    "enterName": "Ampidiro ny anaranao",
    "language": "Fiteny",
    "uiLanguage": "Fiteny fampiharana",
    "uiLanguageHelp": "Manova ny fisehoan'ny app, marika kalandrie, ary ny lalana amin'ny fitaovana ity ihany.",
    "serverLanguage": "Fiteny resaka",
    "serverLanguageHelp": "Manova ny fiteny ampiasain'ny valintenin'ny mpizara sy hafatra fampahatsiahivana ho an'ny kaontinao.",
    "timezone": "Firenena ora",
    "currentTimezone": "Firenena ora ankehitriny",
    "timezoneHelp": "Aseho amin'ity firenena ora ity ny fotoana fampahatsiahivana rehetra.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Tehirizo ny firenena ora",
    "timezoneSaved": "Nohavaozina ny firenena ora",
    "detect": "Fantaro",
    "detectFailed": "Tsy nahita firenena ora",
    "autoDetect": "Fantaro mandeha ho azy avy amin'ny GPS",
    "notifications": "Fampahatsiahivana",
    "notificationsHelp": "Ny fampahatsiahivana manaraka dia mifehy ny fanairana miverimberina rehefa avy nampahatsiahy. Ny fahazoan-dàlana fampahatsiahivana amin'ny fitaovana dia tantanan'ny fikirakirana telefaona.",
    "pushEnabled": "Fampahatsiahivana Push",
    "autoDoneOnFire": "Mariho ho vita ho azy rehefa mandeha",
    "autoDoneOnFireDesc": "Raha tsy mandeha, mijanona ho mavitrika ny fampahatsiahivana mandra-pamaranao azy.",
    "googleCalendar": "Google Kalandrie",
    "google": "Google Kalandrie",
    "googleConnected": "Mifandray",
    "googleDisconnected": "Tsy mifandray",
    "googleConnectedHelp": "Afaka mifanaraka ho azy amin'ny kalandrie ny fampahatsiahivana vaovao.",
    "googleDisconnectedHelp": "Ampifandraiso ny Google Kalandrie mba hitazona fampahatsiahivana sy hetsika mifanaraka.",
    "googleConnectFailed": "Tsy tafiditra ny Google Kalandrie",
    "connected": "Mifandray",
    "disconnected": "Tsy mifandray",
    "connect": "Ampifandraiso",
    "disconnect": "Esory ny fifandraisana",
    "autoSync": "Mifanaraka mandeha ho azy ny fampahatsiahivana vaovao",
    "autosync": "Mifanaraka mandeha ho azy ny fampahatsiahivana vaovao",
    "subscription": "Fisoratana anarana",
    "trialUsed": "Fitsapana: {{used}}/{{total}} nampiasaina",
    "trialStatus": "Misy fitsapana",
    "activeStatus": "Fisoratana anarana mavitrika",
    "expiredStatus": "Lany daty ny fisoratana anarana",
    "unsubscribedStatus": "Tsy nisoratra anarana",
    "about": "Momba",
    "version": "Dikan-teny",
    "logout": "Hiala",
    "logoutTitle": "Hiala",
    "logoutConfirm": "Azonao antoka ve fa te hiala?",
    "noName": "Tsy misy anarana napetraka",
    "serverConnection": "Fifandraisana amin'ny mpizara",
    "serverUrl": "URL mpizara",
    "serverEdit": "Hanova",
    "saveReconnect": "Tehirizo ary mifandraisa indray",
    "resetDefault": "Avereno amin'ny mahazatra",
    "invalidServerUrlTitle": "URL mpizara tsy mety",
    "invalidServerUrlMessage": "Ampidiro URL mpizara http na https marina, ohatra https://example.com",
    "uiLanguageChangeFailed": "Tsy tafiditra ny fanovana fiteny app. Azafady andramo indray.",
    "serverLanguageChangeFailed": "Tsy tafiditra ny fanovana fiteny resaka. Azafady andramo indray.",
    "timezoneChangeFailed": "Tsy tafiditra ny fanovana firenena ora. Azafady andramo indray.",
    "autoSyncChangeFailed": "Tsy tafiditra ny fanovana auto-sync. Azafady andramo indray.",
    "nameChangeFailed": "Tsy tafiditra ny fanovana anarana aseho. Azafady andramo indray.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Antsipirian'ny fampahatsiahivana",
    "editTime": "Hanova fotoana",
    "rename": "Hanova anarana",
    "snooze": "Atsaharo vetivety",
    "snooze15": "Atsaharo 15 minitra",
    "pause": "Ajanony",
    "pauseReminder": "Ajanony ny fampahatsiahivana",
    "resume": "Avereno",
    "resumeReminder": "Avereno ny fampahatsiahivana",
    "skip": "Tsia ny manaraka",
    "skipOccurrence": "Tsia ity indray mandeha ity",
    "syncGoogle": "Mifanaraka amin'ny Google",
    "delete": "Fafao",
    "deleteTitle": "Fafao ny fampahatsiahivana",
    "deleteConfirm": "Hafafana tanteraka ity fampahatsiahivana ity.",
    "deleteRecurringTitle": "Fafao ny fampahatsiahivana miverimberina",
    "deleteRecurringMessage": "Te-hiala amin'ity indray mandeha ity ve ianao sa hamafa ny andiany manontolo?",
    "deleteThisOccurrence": "Atsaharo ity indray mandeha ity",
    "deleteEntireSeries": "Fafao ny andiany manontolo",
    "done": "Vita",
    "markDone": "Mariho ho vita",
    "undo": "Avereno",
    "undoPrompt": "Tianao ho mavitrika indray? Avereno izao.",
    "recurring": "Miverimberina",
    "nextRun": "Manaraka",
    "oneTime": "Indray mandeha",
    "pending": "Miandry",
    "sent": "Nalefa",
    "paused": "Nijanona",
    "active": "Miasa",
    "snoozed": "Natsahatra vetivety",
    "localTime": "Aseho amin'ny ora eo an-toerana",
    "recurrence": "Fiverimberenana",
    "created": "Noforonina",
    "tags": "Marika",
    "fireCount": "Isan'ny mandeha",
    "actions": "Hetra",
    "none": "Tsy misy",
    "snoozeFailed": "Tsy tafiditra ny fanemorana fampahatsiahivana",
    "pauseFailed": "Tsy tafiditra ny fanajanonana fampahatsiahivana",
    "resumeFailed": "Tsy tafiditra ny fanarenana fampahatsiahivana",
    "skipFailed": "Tsy tafiditra ny fanilihana fampahatsiahivana",
    "doneFailed": "Tsy tafiditra ny famaranana fampahatsiahivana",
    "undoFailed": "Tsy tafiditra ny fanarenana sata fampahatsiahivana",
    "deleteFailed": "Tsy tafiditra ny famafana fampahatsiahivana",
    "rescheduleTitle": "Hamerina fandaharam-potoana?",
    "rescheduleMsg": "Latsaka andro ity fampahatsiahivana ity. Te-hamerina fandaharam-potoana ve ianao?",
    "reschedule15": "Ao anatin'ny 15 minitra",
    "reschedule60": "Ao anatin'ny 1 ora",
    "keepOverdue": "Tazomy araka izao"
  },
  "onboarding": {
    "slide1Title": "Tongasoa eto amin'ny FishMemory",
    "slide1Sub": "Mpanampy fampahatsiahivana manokana — avy amin'ny WhatsApp sy natao ho an'ny paosin-tanana.",
    "slide2Title": "Resaho fotsiny amin'ny fomba mahazatra",
    "slide2Sub": "Soraty ny fampahatsiahivana araka ny eritreritrao: \"Ampahatsiahivo aho hiantso an-dreny rahampitso amin'ny 3 ora\" — izahay no mikarakara ny ambiny.",
    "slide3Title": "Aza adino na inona na inona",
    "slide3Sub": "Mahazoa fampahatsiahivana ara-potoana, mandamina amin'ny marika, ary mijanona eo ambony ny zava-dehibe rehetra.",
    "getStarted": "Atombohy",
    "next": "Manaraka",
    "firstReminderTitle": "Mametraha fampahatsiahivana voalohany!",
    "firstReminderHint": "Andramo manoratra toy izao:",
    "firstReminderExample": "Ampahatsiahivo aho hisotro rano rahampitso amin'ny 9 maraina",
    "gotIt": "Azoko!",
    "notifRationaleTitle": "Mijanòna ara-potoana",
    "notifRationaleBody": "Ilaina ny fampahatsiahivana FishMemory mba hampahatsiahy anao ara-potoana. Hahazo fanairana ianao ho an'ny fampahatsiahivana noforoninao ihany.",
    "notifRationaleAllow": "Alefaso ny fampahatsiahivana",
    "notifRationaleLater": "Angamba aoriana",
    "swipeHint": "Sintonina havanana ho an'ny hetsika haingana →",
    "calendarDragHint": "Tantano mba hanitatra ↕"
  }
}
